import { Alert, Snackbar, Slide } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useNotificationStore } from '../../stores/notificationStore';

const GlobalNotification = () => {
  const pathname = useLocation().pathname;
  const { open, content, closeNotification, variant } = useNotificationStore();

  const renderContent = () => {
    switch (variant) {
      case 'success':
        return (
          <Alert severity="success" sx={{ fontSize: '1.25rem' }}>
            {content}
          </Alert>
        );
      case 'error':
        return (
          <Alert severity="error" sx={{ fontSize: '1.25rem' }}>
            {content}
          </Alert>
        );
      case 'warning':
        return (
          <Alert severity="warning" sx={{ fontSize: '1.25rem' }}>
            {content}
          </Alert>
        );
      case 'info':
        return (
          <Alert severity="info" sx={{ fontSize: '1.25rem' }}>
            {content}
          </Alert>
        );
      default:
        return (
          <Alert severity="success" sx={{ fontSize: '1.25rem' }}>
            {content}
          </Alert>
        );
    }
  };

  return (
    <Snackbar
      open={open}
      slots={{ transition: Slide }}
      key={pathname}
      autoHideDuration={2000}
      onClose={closeNotification}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {renderContent()}
    </Snackbar>
  );
};

export default GlobalNotification;
